export default __webpack_public_path__ + "static/media/stories.eeebc6e4.svg";